import React from 'react';

import { IconProps, StyledPath, StyledStrokedGroup, StyledSvg } from '../iconCommons';

export const IconHeartRibbon = ({ color = 'currentColor', size = 'small', ...props }: IconProps) => (
    <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none" size={size} {...props}>
        <StyledStrokedGroup color={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5">
            <StyledPath
                d="M30.201 7.183a7.545 7.545 0 0 0-7.2-4.171c-3.046.168-4.32 1.699-7 3.988-2.68-2.29-3.956-3.82-7-3.988a7.545 7.545 0 0 0-7.2 4.17C-2 15 9.823 23.9 16 29c6.175-5.101 18-14 14.2-21.817zM16 7v22m0-15 5 5m-10 0 5-5"
                color="none"
            />
            <StyledPath
                d="m16 14 4.343-4.343A2.544 2.544 0 1 1 22.14 14H16zm0 0-4.343-4.343A2.544 2.544 0 1 0 9.86 14H16z"
                color="none"
            />
        </StyledStrokedGroup>
    </StyledSvg>
);
